import { AxiosResponse } from 'axios';
import {
  call,
  put,
  select,
  StrictEffect,
  takeLatest,
} from 'redux-saga/effects';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import { parseFormBuilder } from 'src/screens/request/RequestViewPage';
import { FormBuilderData } from 'src/types/formBuilder';
import {
  getMostUsedCategories,
  setMostUsedCategories,
  setMostUsedCategoriesLoading,
} from './reducer';
import { RootState } from '../index';

const { get } = apiRequests;

function* getMostUsedCategoriesSagaListener(): any {
  yield put(setMostUsedCategoriesLoading());

  const project = yield select(
    (state: RootState) => state.projectRetainer.data
  );

  const listForms: FormBuilderData[] = yield select(
    (state: RootState) => state.resources.requestForms
  );

  try {
    const response: AxiosResponse = yield call(get, apiRoutes.PROJECT_REQUEST, {
      'page[size]': 100,
      'sort[by]': 'created_at',
      'sort[direction]': 'desc',
      'filters[project.uuid][]': project?.uuid,
    });

    const countCategories = (response.data.data as any[]).reduce<
      Record<string | number, number>
    >((acc, item) => {
      const formBuilder = parseFormBuilder(item);

      if (formBuilder.id in acc) {
        acc[formBuilder.id] += 1;
      } else {
        acc[formBuilder.id] = 1;
      }

      return acc;
    }, {});

    const sortedCategories = Object.keys(countCategories)
      .sort((a, b) => {
        return countCategories[b] - countCategories[a];
      })
      .map((id) => (!isNaN(Number(id)) ? Number(id) : id));

    const mostUsedForms = sortedCategories
      .map((id) => listForms.find((item) => item.id === id))
      .filter<FormBuilderData>((item): item is FormBuilderData => !!item);

    const sortedForms = [
      ...mostUsedForms,
      ...listForms.filter(
        (item) => !mostUsedForms.find((subItem) => subItem.id === item.id)
      ),
    ];

    yield put(setMostUsedCategories(sortedForms.slice(0, 3)));
  } catch (error) {
    yield put(setMostUsedCategories([]));
  }
}

function* mostUsedCategoriesSaga(): Generator<StrictEffect> {
  yield takeLatest(
    getMostUsedCategories.type,
    getMostUsedCategoriesSagaListener
  );
}

export default mostUsedCategoriesSaga;
